const LINK_TYPES = {
  NONE: 'none',
  TO_LINK: 'toLink',
  TO_MESSAGE: 'toMessage',
  TO_PRODUCT: 'toProduct',
  TO_CATEGORY: 'toCategory',
  TO_MESSAGE_VIDEO: 'toMessageVideo',
};

class BaseBanner {
  constructor(params) {
    this.buttonColor = params.buttonColor;
    this.buttonText = params.buttonText;
    this.buttonTextColor = params.buttonTextColor;
    this.description = params.description;
    this.id = params.id;
    this.imageUrl = params.imageUrl;
    this.index = params.index;
    this.linkType = params.linkType;
    this.linkValue = params.linkValue;
    this.subtitle = params.subtitle;
    this.textColor = params.textColor;
    this.title = params.title;
    this.message = params.message;
  }
}

export { BaseBanner, LINK_TYPES };



// WEBPACK FOOTER //
// ./src/models/BaseBanner.js